/**
 * Circled arrow used by the sidebar count pills — a single glyph rather than the
 * cards' coloured `<span>` + hosted arrow image, because the sidebar needs a smaller
 * badge than the 1rem circle the cards draw.
 *
 * The circle takes `currentColor`, so the three states the design calls for are the
 * pill's own tone tokens and need no separate assets: alerts red (#DF666A), connections
 * blue (#004CA2), and the empty/loading grey (#9D9D9D).
 */
function PillArrowGlyph({ className }: Readonly<{ className?: string }>) {
    return (
        <svg className={className} width="17" height="17" viewBox="0 0 17 17" fill="none" aria-hidden="true" focusable="false">
            <circle cx="8.5" cy="8.5" r="6" fill="currentColor" />
            <path
                d="M6.72171 10.8718C6.68298 10.9119 6.63666 10.9439 6.58545 10.9659C6.53424 10.9879 6.47915 10.9995 6.42342 11C6.36768 11.0005 6.31241 10.9898 6.26082 10.9687C6.20923 10.9476 6.16236 10.9165 6.12295 10.8771C6.08353 10.8376 6.05237 10.7908 6.03126 10.7392C6.01015 10.6876 5.99953 10.6323 6.00002 10.5766C6.0005 10.5208 6.01208 10.4658 6.03408 10.4145C6.05608 10.3633 6.08806 10.317 6.12815 10.2783L9.56691 6.83954H7.24306C7.13173 6.83954 7.02496 6.79531 6.94624 6.71659C6.86752 6.63787 6.82329 6.5311 6.82329 6.41977C6.82329 6.30844 6.86752 6.20167 6.94624 6.12295C7.02496 6.04423 7.13173 6 7.24306 6H10.5802C10.6916 6 10.7983 6.04423 10.8771 6.12295C10.9558 6.20167 11 6.30844 11 6.41977V9.75694C11 9.86827 10.9558 9.97504 10.8771 10.0538C10.7983 10.1325 10.6916 10.1767 10.5802 10.1767C10.4689 10.1767 10.3621 10.1325 10.2834 10.0538C10.2047 9.97504 10.1605 9.86827 10.1605 9.75694V7.43309L6.72171 10.8718Z"
                fill="#FFFFFF"
            />
        </svg>
    );
}

export default PillArrowGlyph;
